import '../styles/main.css';
import '../styles/tailwind.css';
import React from 'react';

import { Provider } from 'react-redux';
import Head from 'next/head';
import App from 'next/app';

import withReduxStore from 'utils/with-redux-store';
import { appWithTranslation } from 'utils/with-i18next';

import 'fontsource-metropolis';
import '@typefaces-pack/typeface-inter';
import TagManager from 'react-gtm-module';
import { PropertiesContextProvider } from 'contexts/PropertiesContext';
import { BookingsContextProvider } from 'contexts/BookingsContext';
import { TicketContextProvider } from 'contexts/TicketContext';
import { UserContextProvider } from 'contexts/UserContext';

const tagManagerArgs = {
  id: 'GTM-NHZJKL8',
};

class Srr extends App {
  componentDidMount() {
    if (process.env.NODE_ENV === 'production') {
      TagManager.initialize(tagManagerArgs);
    }
  }
  render() {
    const { Component, pageProps, reduxStore } = this.props;
    const getLayout = Component.getLayout || (page => page);

    return (
      <>
        <Head>
          <title>Soulrooms - Digitising Rentals.</title>
        </Head>

        <UserContextProvider>
          <PropertiesContextProvider>
            <BookingsContextProvider>
              <TicketContextProvider>
                <Provider store={reduxStore}>{getLayout(<Component {...pageProps}></Component>)}</Provider>
              </TicketContextProvider>
            </BookingsContextProvider>
          </PropertiesContextProvider>
        </UserContextProvider>
      </>
    );
  }
}

export default appWithTranslation(withReduxStore(Srr));
